<template>
  <div class="setup-switch" :class="switchClass">
    <input :id="inputId"
           :name="name"
           :checked="value"
           :value="value"
           @input="onToggle"
           type="checkbox"
           class="switcher"/>
    <label :for="inputId">
      <div class="spinner" v-if="waiting"></div>
    </label>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";

@Component({
  name: "SetupToggler"
})
export default class SetupToggler extends Vue {

  @Prop({default: ''})
  name: string

  @Prop({default: false})
  value: boolean

  @Prop({default: false})
  disabled: boolean

  @Prop({default: false})
  waiting: boolean

  inputId = ''

  created() {
    this.inputId = 'setup-input-' + Math.random() + new Date().getMilliseconds();
  }

  get disabledSwitch(): boolean {
    return this.disabled || this.waiting;
  }

  onToggle(event) {
    this.$emit('input', event.target.checked);
    this.$emit('toggle', event.target.checked);
  }

  get switchClass() {
    return {
      waiting: this.waiting,
      'setup-switch__loading': this.waiting
    }
  }
}
</script>

<style scoped lang="less">
.setup-switch {
  display: inline-block;

  &.setup-switch__loading {
    input[type=checkbox].switcher + label:after {
      left: 22px;
      background: #d4e9b5;
    }
  }

  &.waiting {
    .spinner {
      position: absolute;
      left: 18px;
      top: 0;
    }
  }
}


.spinner {
  display: inline-block;
  width: 25px;
  height: 25px;
  z-index: 2;
}

.spinner:after {
  content: " ";
  display: block;
  width: 22px;
  height: 22px;
  margin: 5px;
  border-radius: 50%;
  border: 3px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: spinner 1.2s linear infinite;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
